/**
 * 장비 와이어 계약. 백엔드 `DeviceResponse` · `DeviceCreateRequest` ·
 * `DeviceUpdateRequest` · `DeviceTypeResponse`.
 *
 * 실측(2026-09-21) 으로 응답 12 개 필드가 스펙과 일치함을 확인했다.
 */

export type DeviceStatus = "ACTIVE" | "DELAYED" | "OFFLINE";

export const DEVICE_STATUS_LABELS: Record<DeviceStatus, string> = {
  ACTIVE: "통신 중",
  DELAYED: "지연",
  OFFLINE: "끊김",
};

/** 응답 곳곳에서 장비를 가리키는 공통 조각. 백엔드 `DeviceRef`. */
export interface DeviceRef {
  id: number;
  deviceId: string;
  deviceName: string;
  deviceType: DeviceTypeName;
}

export enum DeviceTypeName {
  HEAT_INDEX = "HEAT_INDEX",
  GAS_DETECTOR = "GAS_DETECTOR",
  SMART_BAND = "SMART_BAND",
}

export interface TelemetryField {
  name: string;
  displayName: string;
  type: "INTEGER" | "DOUBLE";
  unit?: string | null;
}

export interface DeviceType {
  name: string;
  displayName: string;
  hasEvent: boolean;
  telemetryFields: TelemetryField[];
}

export interface Device {
  id: number;
  deviceId: string;
  type: DeviceTypeName;
  siteId: number;
  siteName: string;
  vendorId: number;
  vendorName: string;
  name: string | null;
  latitude: number | null;
  longitude: number | null;
  status: DeviceStatus;
  lastSeenAt: string | null;
}

/** 생성은 `id`(장비 고유 문자열)만 필수다. */
export interface DeviceCreateRequest {
  id: string;
  type: DeviceTypeName;
  siteId: number;
  vendorId: number;
  name?: string;
  latitude?: number;
  longitude?: number;
}

export interface DeviceUpdateRequest {
  siteId: number;
  vendorId: number;
  name?: string | null;
  latitude?: number | null;
  longitude?: number | null;
}

export interface BulkUploadFailure {
  rowNumber: number;
  deviceId: string;
  reason: string;
}

export interface BulkUploadResult {
  total: number;
  success: number;
  failed: number;
  failures: BulkUploadFailure[];
}
